<template>
  <i-dx-popup :popupVisible="popupVisible" :title="title" @popupCloseButtonClick="closeBtn" height="80vh" width="80vw">
    <template v-slot:grid>
      <div class="v-application" style="display: block !important">
        <v-row no-gutters class="px-6 py-5" style="height: calc(80vh - 178px)">
          <v-col cols="3" class="pr-5 d-flex flex-column h-full">
            <h4 class="editor-label">사업장 목록</h4>
            <v-card
              class="pa-3 overflow-y-auto"
              height="100%"
              style="touch-action: auto; overscroll-behavior: contain; -webkit-overflow-scrolling: touch"
              @wheel.native.stop
            >
              <div style="height: 100%; overflow-y: auto; overscroll-behavior: contain; -webkit-overflow-scrolling: touch" @wheel.stop="">
                <v-treeview
                  dense
                  :ref="treeView"
                  activatable
                  :items="hrTree"
                  @update:active="searchHr"
                  open-all
                  class="popup-treeview"
                  style="touch-action: auto"
                >
                  <template v-slot:label="{ item }">
                    <span>{{ item.name }}</span>
                  </template>
                </v-treeview>
              </div>
            </v-card>
          </v-col>
          <v-col :cols="mode !== 'single' ? 6 : 9" class="d-flex flex-column h-full">
            <h4 class="editor-label">인원 목록</h4>
            <div style="height: 96%; background-color: #f8f9fa; padding: 8px">
              <i-search-panel :searchPanel="true"></i-search-panel>
              <DxDataGrid :ref="dxDataGridRef" :data-source="humanResources" key-expr="id" height="90%" :selection="{ showCheckBoxesMode: 'none' }">
                <DxScrolling mode="virtual" row-rendering-mode="virtual" :preload-enabled="true" :use-native="true" />
                <DxColumn
                  data-field="clntNm"
                  data-type="string"
                  :width="isAllComp ? '150px' : '200px'"
                  alignment="center"
                  caption="고객사"
                  :allow-editing="false"
                />
                <DxColumn data-field="korNm" data-type="string" width="150px" alignment="center" caption="이름" :allow-editing="false" />

                <DxColumn data-field="jbrp" data-type="string" width="100px" alignment="center" caption="직책" :allow-editing="false">
                  <DxLookup :data-source="jbrpList" width="150px" value-expr="minorCd" display-expr="minorNm" />
                </DxColumn>
                <DxColumn data-field="grpAuthCd" data-type="string" alignment="center" caption="권한" :allow-editing="false">
                  <DxLookup :data-source="grpAuthList" value-expr="grpAuthCd" display-expr="grpAuthNm" />
                </DxColumn>
                <DxColumn
                  v-if="isAllComp"
                  data-field="compAuthYn"
                  data-type="string"
                  width="100px"
                  alignment="center"
                  :caption="`접근권한`"
                  :allow-editing="false"
                  header-cell-template="compAuthYnHeader"
                  cell-template="compAuthYnTemplate"
                />
                <template #compAuthYnHeader="{ data }">
                  <div style="white-space: pre-line">
                    {{ data.column.caption }}
                    <v-tooltip top color="#f2f2f2" max-width="500px">
                      <template v-slot:activator="{ on }">
                        <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                      </template>
                      <div>
                        <h5 class="editor-label">{{ `현재사업장: ${getCurrentCompNm}` }}</h5>
                      </div>
                      <div class="d-flex flex-column" style="white-space: pre-line">
                        <div class="d-flex align-center">
                          <v-icon medium color="primary">mdi-check</v-icon>
                          <span class="editor-label">현재 사업장에 접근 가능한 인원</span>
                        </div>
                        <div class="d-flex align-center">
                          <v-icon medium color="error">mdi-close</v-icon>
                          <span class="editor-label">현재 사업장에 접근 불가능한 인원</span>
                        </div>
                      </div>
                    </v-tooltip>
                  </div>
                </template>
                <template #compAuthYnTemplate="{ data: cellInfo }">
                  <v-icon v-if="cellInfo.data.compAuthYn == 'Y'" medium color="primary">mdi-check</v-icon>
                  <v-icon v-else medium color="error">mdi-close</v-icon>
                </template>
                <DxColumn
                  data-field
                  caption="선택"
                  alignment="center"
                  width="70px"
                  :allow-editing="false"
                  :allow-sorting="false"
                  cell-template="selectButton"
                  header-cell-template="selectHeader"
                />
                <template #selectButton="{ data: cellInfo }">
                  <v-btn
                    v-if="cellInfo.data.delYn != 'Y'"
                    text
                    height="28"
                    class="move"
                    :color="checkColor(cellInfo) ? 'primary' : 'btn_text'"
                    @click="selectHr(cellInfo)"
                  >
                    <svg-icon icon-class="grid-check" width="24" height="24"></svg-icon>
                  </v-btn>
                </template>
                <template #selectHeader>
                  <div class="select-header">
                    <span>선택</span>
                    <v-btn
                      v-if="mode !== 'single'"
                      icon
                      x-small
                      class="ml-1"
                      :color="allSelected ? 'primary' : 'btn_text'"
                      @click.stop="toggleAllSelection"
                    >
                      <svg-icon icon-class="grid-check" width="20" height="20"></svg-icon>
                    </v-btn>
                  </div>
                </template>
              </DxDataGrid>
            </div>
          </v-col>
          <v-col v-if="mode !== 'single'" cols="3" class="pl-5 d-flex flex-column h-full">
            <h4 class="editor-label">{{ `선택된 인원 (${copySelectedHrs.length}명)` }}</h4>
            <DxList
              style="height: 100%; background-color: #f8f9fa; padding: 8px"
              ref="dxlist"
              id="simple-dxlist"
              class="popup-list"
              height="100%"
              :data-source="copySelectedHrs"
              :repaint-changes-only="true"
              key-expr="esgHrNo"
              show-scrollbar="always"
              :allow-item-deleting="true"
              :show-selection-controls="true"
              :search-enabled="true"
              :search-editor-options="{ placeholder: '선택된 인원 검색' }"
              :item-delete-mode="'static'"
              searchExpr="korNm"
              select-all-mode="allPages"
              item-template="list-item"
            >
              <template #list-item="{ data: item }">
                <div>
                  <v-icon v-if="item.delYn == 'Y'" x-small color="secondary">mdi-close-box-outline</v-icon>

                  <!-- <svg-icon v-if="item.delYn == 'Y'" icon-class="x-circle" style="height: 1rem;"></svg-icon> -->
                  <!-- {{ item.korNm + ' (' + item.jbrp + ')' }} -->
                  <div class="list-title">{{ displayUser(item).korNm }}</div>
                  <span class="list-sub">{{
                    displayUser(item).clntNm ? displayUser(item).clntNm + ' > ' + displayUser(item).grpAuthNm : '' + displayUser(item).grpAuthNm
                  }}</span>
                </div>
              </template>
            </DxList>
          </v-col>
        </v-row>
        <v-divider />
        <v-btn elevation="0" large color="primary" class="float-right rounded mr-6 mt-5" @click="btnApply">적용</v-btn>
      </div>
    </template>
  </i-dx-popup>
</template>

<script>
import IDxPopup from '@/components/common/iDxPopup.vue'
import { DxList } from 'devextreme-vue/list'
import { getCommonCode } from '@/api/common/commonApi'
import { getGrpAuth } from '@/api/common/commonApi'
import { getHumanResources, getHrGroup } from '@/api/component/component'

import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import iSearchPanel from '@/components/common/iSearchPanel.vue'
export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    IDxPopup,
    DxList,
    iSearchPanel,
  },
  props: {
    id: {
      // 중복 방지를 위한 ID 값
      type: String,
      default: () => '',
    },
    popupVisible: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: () => '',
    },
    company: {
      type: String,
      default: () => '',
    },
    selectedHrs: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: () => 'single',
    },
  },
  data() {
    return {
      treeView: 'treeview',
      dxDataGridRef: 'datagrid',
      humanResources: [],
      hrGroups: [],
      hrTree: [],
      jbrpList: [],
      grpAuthList: [],
      path: '',
      copySelectedHrs: [],
      transformedData: [],
      param: {},
      allSelected: false,
      isAllComp: true,
    }
  },
  computed: {
    getCurrentCompNm() {
      return this.getCompNm()
    },
  },
  watch: {
    selectedHrs: {
      immediate: true, // 컴포넌트가 마운트 되는 즉시 실행
      handler(newVal, oldVal) {
        this.copySelectedHrs = JSON.parse(JSON.stringify(newVal))
        this.$nextTick(() => {
          this.updateAllSelectedState()
        })
      },
      deep: true, //객체,배열 내부까지 감시
    },
    id: {
      immediate: true, // 컴포넌트가 마운트 되는 즉시 실행
      handler(newVal, oldVal) {
        const [index, indexRed, workId, riskFactorId, riskReduceMeasuresId] = this.id.split('_')
        //쪼개야함!!
        this.param = {
          index: index,
          indexRed: indexRed,
          workId: workId,
          riskFactorId: riskFactorId,
          riskReduceMeasuresId: riskReduceMeasuresId,
        }
      },
      deep: true, //객체,배열 내부까지 감시
    },
    copySelectedHrs: {
      handler() {
        this.updateAllSelectedState()
      },
      deep: true,
    },
    humanResources() {
      this.updateAllSelectedState()
    },
  },
  mounted() {
    this.setCombobox()
  },
  methods: {
    toggleAllSelection() {
      if (this.mode === 'single') return
      const selectableHrs = this.humanResources.filter((hr) => hr.delYn !== 'Y')
      if (!selectableHrs.length) return

      if (!this.allSelected) {
        const selectedIds = new Set(this.copySelectedHrs.map((hr) => hr.esgHrNo))
        const merged = [...this.copySelectedHrs]
        selectableHrs.forEach((hr) => {
          if (!selectedIds.has(hr.esgHrNo)) {
            merged.push(hr)
          }
        })
        this.copySelectedHrs = merged
      } else {
        const selectableIds = new Set(selectableHrs.map((hr) => hr.esgHrNo))
        this.copySelectedHrs = this.copySelectedHrs.filter((hr) => !selectableIds.has(hr.esgHrNo))
      }
      this.updateAllSelectedState()
    },
    updateAllSelectedState() {
      if (this.mode === 'single') {
        this.allSelected = false
        return
      }
      const selectableHrs = this.humanResources.filter((hr) => hr.delYn !== 'Y')
      if (!selectableHrs.length) {
        this.allSelected = false
        return
      }
      const selectedIds = new Set(this.copySelectedHrs.map((hr) => hr.esgHrNo))
      this.allSelected = selectableHrs.every((hr) => selectedIds.has(hr.esgHrNo))
    },
    checkColor(cellInfo) {
      let temp = this.copySelectedHrs
      let exists = temp.some((obj) => JSON.stringify(obj.esgHrNo) === JSON.stringify(cellInfo.data.esgHrNo))
      return exists
    },
    searchHr(node) {
      if (node.length < 1) return
      const target = node[0]
      this.isAllComp = target === 'ALL'
      let params = {
        clntId: this.getClntId(),
      }
      const [clntId, company, grpAuth, cd] = target.split('_')

      let grpAuthCd = cd ? grpAuth + '_' + cd : grpAuth
      // params.compId = company
      params.clntId = clntId && clntId !== 'ALL' ? clntId : this.getClntId()
      // params.compId = target === 'ALL' ? null : company ? company : this.getCompId()
      params.compId = company ? company : this.getCompId()
      params.grpAuthCd = target === 'ALL' ? 'all' : grpAuthCd
      this.humanResources = []
      getHumanResources(params, true).then((response) => {
        this.humanResources = response.list
        this.setPath(company, grpAuthCd)
        this.$nextTick(() => {
          this.updateAllSelectedState()
        })
      })
    },
    btnApply() {
      this.vToastifyPrompt(
        this.$t('선택한 인원을 적용하시겠습니까?'),
        'info',
        (current) => {
          let selected = this.copySelectedHrs
          if (this.param) {
            selected.forEach((el) => {
              el.riskFactorId = this.param.riskFactorId
              el.riskReduceMeasuresId = this.param.riskReduceMeasuresId
              el.workId = this.param.workId
            })
          }
          this.$emit('apply', selected)
        },
        null,
        true
      )
    },
    selectHr(cellInfo) {
      const temp = this.copySelectedHrs

      if (this.mode === 'single') {
        let exists = temp.some((obj) => JSON.stringify(obj.esgHrNo) === JSON.stringify(cellInfo.data.esgHrNo))
        if (exists) {
          this.vToastify(this.$t('이미 선택된 인원입니다.'), 'info')
          return
        }
        // SingleMode인 경우 선택한 인원 row 정보를 바로 반환하고 종료
        const selected = cellInfo.data
        this.$emit('apply', selected, true)
        this.$emit('popupClose')
      } else {
        const index = temp.findIndex((obj) => JSON.stringify(obj.esgHrNo) === JSON.stringify(cellInfo.data.esgHrNo))
        if (index !== -1) {
          this.copySelectedHrs.splice(index, 1)
          this.updateAllSelectedState()
          return
        }
        this.copySelectedHrs.push(cellInfo.data)
        this.updateAllSelectedState()
      }
    },
    setHrTree(data) {
      const treeMap = {}
      data.forEach((item) => {
        if (item.compId) {
          let company =
            treeMap[item.clntId + '_' + item.compId] ||
            (treeMap[item.clntId + '_' + item.compId] = { id: item.clntId + '_' + item.compId, name: item.compNm, children: {} })
          if (item.grpAuthCd) {
            company.children[item.clntId + item.grpAuthCd] = {
              id: item.clntId + '_' + item.grpAuthCd,
              name: item.grpAuthNm,
            }
          }
        }
      })
      this.transformedData = Object.values(treeMap).map((company) => ({
        id: company.id,
        name: company.name,
        children: Object.values(company.children).map((grpAuth) => ({
          id: grpAuth.id,
          name: grpAuth.name,
        })),
      }))
      //사업장 목록 트리설정 후 최상단 id 를 클릭
      if (this.transformedData.length > 0) {
        this.searchHr(['ALL'])
      }
      this.hrTree = [
        {
          id: 'ALL',
          name: '전체',
          children: this.transformedData,
        },
      ]
    },
    setPath(company, grpAuth) {
      if (!company) this.path = ''
      else if (!grpAuth) this.path = `[ ${company} ]`
      else this.path = `[ ${company} > ${grpAuth} ]`
    },
    setCombobox() {
      let params = {
        clntId: this.getClntId(),
        // compId: this.getCompId() //(compId 입력시 해당 사업장만 목록 조회)
      }
      let grpParams = {
        platformType: 'M',
      }
      Promise.all([getHrGroup(params), getCommonCode('CM007'), getGrpAuth(grpParams)]).then((response) => {
        this.hrGroups = response[0].list
        this.setHrTree(this.hrGroups)
        this.jbrpList = response[1].list
        this.grpAuthList = response[2].list
      })
    },
    getUserInfo(esgHrNo, type) {
      if (this.copySelectedHrs.length > 0) {
        let selected = this.copySelectedHrs.find((element) => element.esgHrNo == esgHrNo)
        if (type == 'hpNo') return selected ? selected.hpNo : ''
        if (type == 'jbrp') return selected ? selected.jbrpNm : ''
        if (type == 'korNm') return selected ? selected.korNm : ''
      }
    },
    displayUser(item) {
      let user = this.humanResources.find((element) => element.esgHrNo == item.esgHrNo)
      // if (user) {
      //   let text = `${user.korNm} (${user.grpAuthNm})`
      //   return text
      // } else {
      //   let text = `${item.korNm} (${item.grpAuthNm})`
      //   return text
      // }
      return user ? user : item
    },
    closeBtn() {
      this.$emit('popupClose')
    },
  },
}
</script>

<style lang="scss" scoped></style>
